function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import { getHeaders } from "../const";
import axios from 'axios';
import { encodeUrlParam } from "./common";
import { message } from "../components/GlobalMessage";
export var ENV_CACHE = 'env_cache';
export var initialEnv = function initialEnv() {
  var hostname = window.location.hostname;
  if (/micun\.com/.test(hostname)) {
    return '';
  }
  var cache = localStorage.getItem(ENV_CACHE);
  if (/localhost/.test(hostname)) {
    return cache || 'dev';
  }
  if (/dev/.test(hostname)) {
    return cache || 'dev';
  }
  if (/beta/.test(hostname)) {
    return cache || 'beta';
  }
  return '';
};
export var setEnv = function setEnv(nextEnv) {
  env = nextEnv;
  localStorage.setItem(ENV_CACHE, nextEnv);
};
export var env = initialEnv();
export var isAbsolute = function isAbsolute(url) {
  return /^http/.test(url);
};
export var transformUrl = function transformUrl(env, config) {
  // return config
  var _config$url = config.url,
    url = _config$url === void 0 ? '' : _config$url;
  var abs = isAbsolute(url);
  if (abs) {
    return config;
  }
  var isSSO = /^\/?sso/.test(url);
  var isInternal = /^\/internal/.test(url);
  if (env && env !== 'prod') {
    if (isSSO) {
      config.url = "//sso.".concat(env, ".micun.cn").concat(url);
    } else if (isInternal) {
      config.url = "//internal.".concat(env, ".micun.cn").concat(url.replace(/^\/internal/, ''));
    } else {
      config.url = "//api.".concat(env, ".micun.cn").concat(url);
    }
  } else {
    if (isSSO) {
      config.url = "//sso.micun.com".concat(url);
    } else if (isInternal) {
      // internal.micun.cn 为特殊内网地址，不对外开放，线上环境也是使用的 micun.cn
      config.url = "//internal.micun.cn".concat(url.replace(/^\/internal/, ''));
    } else {
      config.url = "//api.micun.com".concat(url);
    }
  }
  return config;
};
var currentRequestCount = 0;
var lastResponseTime = 0;
export var instance = axios.create({
  paramsSerializer: function paramsSerializer(params) {
    return encodeUrlParam(params);
  }
});
instance.interceptors.request.use(function (config) {
  Object.assign(config.headers, getHeaders());
  currentRequestCount++;
  return transformUrl ? transformUrl(env, config) : config;
});
instance.interceptors.response.use(function (response) {
  currentRequestCount--;
  if (currentRequestCount === 0) {
    lastResponseTime = Date.now();
  }
  // console.log('fetch response', response)
  if (response.data != null && _typeof(response.data) === 'object') {
    response.data.$response = response;
  }
  return response.data;
}, function (error) {
  currentRequestCount--;
  if (currentRequestCount === 0) {
    lastResponseTime = Date.now();
  }
  // console.log('fetch error', error)
  var response = {};
  if (error.response) {
    response = {
      data: error.response.data,
      code: error.response.status,
      msg: error.response.statusText,
      $response: error
    };
  } else {
    response = {
      data: error.message,
      code: -9999,
      msg: error.code,
      $response: error
    };
  }
  return response;
});
instance.interceptors.response.use(function (response) {
  var _ref = response,
    code = _ref.code,
    msg = _ref.msg,
    $response = _ref.$response;
  var _ref2 = $response || {},
    config = _ref2.config;
  var _ref3 = config || {},
    _ref3$errorTip = _ref3.errorTip,
    errorTip = _ref3$errorTip === void 0 ? true : _ref3$errorTip;
  if (code === 0 || code >= 200 && code < 300 || code === 401) {
    return response;
  } else if (errorTip) {
    message.error("(".concat(code, ") ").concat(msg));
  }
  return response;
});
var bindMethod = function bindMethod(method) {
  return function (config) {
    return instance(_objectSpread(_objectSpread({}, config), {}, {
      params: config.query,
      method: method
    }));
  };
};
export var fetch = function fetch(config) {
  return instance(_objectSpread(_objectSpread({}, config), {}, {
    params: config.query
  }));
};
export var get = bindMethod('get');
export var post = bindMethod('post');
export var put = bindMethod('put');
export var del = bindMethod('delete');
export function hasPendingRequests() {
  return currentRequestCount > 0 || Date.now() - lastResponseTime < 100;
}